import {SiteBasics as SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes as ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import {SiteType} from 'Common/SiteType';
import { LoginRoutes } from 'Shared/routes/LoginRoutes';
import { Environment } from 'Common/Environment';


export function selectRoutes(build:Environment,site:SiteBasics)
{
	switch(site.type) {
		case SiteType.venue:	
			const settings = (new VenueSettingsFactory()).createSettings(site.key);
			const routerClass = settings.routes();
			return (new routerClass(settings.pages())).routes();

		case SiteType.artist:
			return (new ArtistRoutes()).routes();

		case SiteType.login:
			return (new LoginRoutes(build)).routes();
	}
	Assert.check(false);
}

